import React,{useEffect} from 'react'

const StaffingSolution = () => {
    useEffect(() => {
            if (!window.location.hash) {
                window.scrollTo(0, 0);
            }
        }, []);
    const steps = [
        {
            number: 1,
            title: 'Share the requirement',
            description: 'Understanding client requirements is key when it comes to staffing solutions. We ask our clients their demands, requirements, and goals to carefully analyse the suitable employees to recruit for their business.',
            image: 'https://apoorvaclinic.com/Backup_old_website/images/icon-service.png',
            color: 'purple-200',
            bgColor: 'bg-pink-300',
        },
        {
            number: 2,
            title: 'Shortlist the most suitable candidate',
            description: 'After fully understanding your requirements, our staffing experts will shortlist the perfect candidates for your project. What makes this step highly effective is our extremely skilled pool of talent that will be the most suitable for you.',
            image: 'https://apoorvaclinic.com/Backup_old_website/images/icon-service.png',
            color: 'blue-700',
            bgColor: 'bg-blue-200',
        },
        {
            number: 3,
            title: 'Arrange the interview',
            description: 'Once we’ve shortlisted a list of skilled candidates who are perfectly suited for the job, we will arrange and line up interviews to select the one who is the most suitable. Our interview process is highly detailed and efficient.',
            image: 'https://apoorvaclinic.com/Backup_old_website/images/icon-service.png',
            color: '[#09588D]',
            bgColor: 'bg-green-200',
        },
        {
            number: 4,
            title: 'Complete the onboarding process',
            description: 'Now that the most suitable candidate has been selected, the onboarding process is followed. This includes signing and submitting important documents, making them aware of the terms and conditions to be followed and more.',
            image: 'https://apoorvaclinic.com/Backup_old_website/images/icon-service.png',
            color: '[#F86F4B]',
            bgColor: 'bg-rose-200',
        },
        {
            number: 5,
            title: 'Keep the track of the candidate with tools',
            description: 'Our staffing services do not end after we’ve provided the perfect candidate for your enterprise. To ensure that the employees are productive, we utilise several time-tracking tools that help us monitor and analyse their performance.',
            image: 'https://apoorvaclinic.com/Backup_old_website/images/icon-service.png',
            color: '[#09588D]',
            bgColor: 'bg-orange-200',
        },
        {
            number: 6,
            title: 'Support the client/candidate till the contract lasts',
            description: 'What makes our clients prefer our staffing solutions time and time again is the overall support they receive. The timely and efficient support does not end after onboarding, we ensure that everything is taken care of till the contract lasts.',
            image: 'https://apoorvaclinic.com/Backup_old_website/images/icon-service.png',
            color: '[#09588D]',
            bgColor: 'bg-orange-200',
        },
    ];
    return (
        <div className='pt-36'>
            <div className="curslide">
                <div
                    className="w-full h-[500px] bg-cover bg-center bg-no-repeat"
                    style={{
                        backgroundImage: `linear-gradient(to right, rgba(254, 247, 237, 1), rgba(255, 255, 255, 0)), url('https://static.zohocdn.com/sites/stock-images/images/zpstock-image-39.jpg')`,
                    }}
                ></div>

                <div className="absolute top-0 left-0 w-full h-full flex items-start justify-start">
                    <div className="container mx-auto px-4 py-8">
                        <div className="flex flex-col justify-start items-start h-full">
                            <div className="w-full md:w-1/2 mt-52 lg:mt-[420px]">
                                <h2 data-aos="fade-up" className="text-left text-black font-recoleta text-[58px] 2xl:text-[40px] lg:text-[32px]">
                                    Staffing Solution Process
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="lg:w-[80%] lg:max-w-8xl lg:mx-auto py-10 px-4 font-recoleta">
                {steps.map((step, index) => {
                    const isReversed = index % 2 !== 0;
                    return (
                        <div
                            key={index}
                            // style={{placeContent:'center'}}
                            className={`relative text-center flex flex-col lg:flex-row ${isReversed ? 'lg:flex-row-reverse' : ''
                                } items-center w-full mb-10 `}
                        >
                            <div className={`absolute left-10 top-20  w-1 rounded-full z-0 hidden lg:block ${index < steps.length - 1
                                ? `bg-${step.color}`
                                : 'bg-transparent'
                                }`}
                                style={{
                                    backgroundColor: `var(--tw-${step.color})`,
                                }}
                            ></div>
                            <div className={`relative  flex items-center justify-center text-${step.color} ${step.bgColor} rounded-full w-20 h-20 text-xl font-bold m-4 shrink-0 lg:block hidden`}
                            >
                                <div
                                    className={`absolute top-1/2 ${isReversed ? 'lg:left-[-16px] ' : 'lg:right-[-16px]'
                                        }  w-10 h-1 ${step.bgColor}`}
                                ></div>
                                {index < steps.length - 1 && (
                                    <div
                                        className={`hidden lg:block absolute bottom-[-75px] left-1/2 transform -translate-x-1/2 w-1 h-20 ${step.bgColor}`}
                                    />
                                )}
                                <span className='absolute mt-[26px] -ml-1'>{step.number}</span>
                            </div>
                            <div className={`relative  flex items-center justify-center text-${step.color} ${step.bgColor}  w-full h-28 text-xl font-bold shrink-0 block lg:hidden`}
                            >
                                <div
                                    className={` ${step.bgColor}`}
                                ></div>
                               <span className='text-[52px]'> {step.number}</span>
                            </div>

                            <div className={`bg-${step.color} text-white p-4 shrink-0 2xl:w-[9%]  lg:w-[157px] 2xl:h-[9%]  lg:h-[157px] z-1 lg:block hidden`}>
                                <img src={step.image} alt="" className="" />
                            </div>
                            <div className={`bg-${step.color} text-white  shrink-0   w-full z-1 block lg:hidden`}>
                                <img src={step.image} alt="" className="justify-self-center" />
                            </div>

                            <div className="bg-white shadow-[0_30px_60px_-12px_rgba(50,50,93,0.25),0_18px_36px_-18px_rgba(0,0,0,0.3),0_-12px_36px_-8px_rgba(0,0,0,0.025)] p-5 w-full 2xl:h-[9%]  lg:h-[157px]">
                                <h3
                                    className={`text-${step.color} font-bold text-[34px] mb-2 2xl:text-[28px] lg:text-[22px]`}
                                >
                                    {step.title}
                                </h3>
                                <p className="text-gray-700 m-0 2xl:text-[22px] lg:text-[18px] text-[28px]">
                                    {step.description}
                                </p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}
export default StaffingSolution;
